module.exports = __webpack_public_path__ + "img/violet_037.dae67e21.png";